var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCashback2X4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_gambling_2105220",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M7.623,13.92A5.723,5.723,0,0,0,5.721,25.2a5.724,5.724,0,0,0,1.9-11.285Zm-.2,10.519a4.947,4.947,0,0,1-1.651-9.753,4.947,4.947,0,0,1,1.651,9.753Z",
    transform: "translate(-1.036 -7.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M29.2,29.187l-1-1.736a.268.268,0,0,0-.4-.1l-.8.46a6.162,6.162,0,0,0,1.251,2.247l.8-.46A.309.309,0,0,0,29.2,29.187Z",
    transform: "translate(-14.008 -14.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M37.552,33.5H35.6a.326.326,0,0,0-.3.306v.919a5.242,5.242,0,0,0,1.251.153,4.945,4.945,0,0,0,1.251-.153v-.919A.284.284,0,0,0,37.552,33.5Z",
    transform: "translate(-18.155 -17.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M44.182,18.168l1,1.736a.268.268,0,0,0,.4.1l.8-.46A6.162,6.162,0,0,0,45.133,17.3l-.751.46A.342.342,0,0,0,44.182,18.168Z",
    transform: "translate(-22.584 -9.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M28,20.006a.268.268,0,0,0,.4-.1l1-1.736a.324.324,0,0,0-.1-.409l-.751-.46A5.2,5.2,0,0,0,27.3,19.547Z",
    transform: "translate(-14.158 -9.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M45.171,27.451l-1,1.736a.324.324,0,0,0,.1.409l.8.46a5.2,5.2,0,0,0,1.251-2.247l-.751-.46A.268.268,0,0,0,45.171,27.451Z",
    transform: "translate(-22.572 -14.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M35.3,14.872a.326.326,0,0,0,.3.306h1.951a.326.326,0,0,0,.3-.306v-.919A5.242,5.242,0,0,0,36.6,13.8a4.945,4.945,0,0,0-1.251.153v.919Z",
    transform: "translate(-18.155 -7.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M36.331,21.03a2.051,2.051,0,0,0-2.5,2.553,2,2,0,0,0,1.4,1.43,2.051,2.051,0,0,0,2.5-2.553A1.846,1.846,0,0,0,36.331,21.03Z",
    transform: "translate(-17.385 -11.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M37.758,18.738l-.65.409a.758.758,0,0,1-1.1-.306l-1-1.736a.789.789,0,0,1,.3-1.123l.65-.357a5.545,5.545,0,0,0-1.9-1.123v.766a.8.8,0,0,1-.8.817H31.3a.8.8,0,0,1-.8-.817V14.5a5.545,5.545,0,0,0-1.9,1.123l.65.357a.856.856,0,0,1,.3,1.123l-1,1.736a.758.758,0,0,1-1.1.306l-.65-.409a7.8,7.8,0,0,0-.1,1.123,7.8,7.8,0,0,0,.1,1.123l.65-.409a.758.758,0,0,1,1.1.306l1,1.736a.831.831,0,0,1-.3,1.123l-.65.357a5.545,5.545,0,0,0,1.9,1.123v-.766a.8.8,0,0,1,.8-.817h1.951a.8.8,0,0,1,.8.817v.766a5.545,5.545,0,0,0,1.9-1.123l-.65-.357a.844.844,0,0,1-.3-1.123l1-1.736a.758.758,0,0,1,1.1-.306l.65.409a7.8,7.8,0,0,0,.1-1.123A7.8,7.8,0,0,0,37.758,18.738Zm-5.5,3.728A2.578,2.578,0,0,1,29.7,19.913a2.528,2.528,0,1,1,5.054,0A2.5,2.5,0,0,1,32.254,22.466Z",
    transform: "translate(-13.858 -7.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M7.226,16.912a4.1,4.1,0,0,0-3.2,3.319,4.112,4.112,0,1,0,3.2-3.319Zm1.3,6.894v.715h-.9v-.715a2.521,2.521,0,0,1-.9-.46,2.555,2.555,0,0,1-.55-.868l.851-.306a1.392,1.392,0,0,0,.45.613c.5.409,1.451.306,1.451-.511,0-.664-.7-.817-1.5-1.174a1.575,1.575,0,0,1-1.1-1.481,1.454,1.454,0,0,1,1.251-1.43v-.664h.9v.664a1.368,1.368,0,0,1,.751.409,2.147,2.147,0,0,1,.45.715l-.851.306a.813.813,0,0,0-.851-.562c-.5,0-.7.255-.7.562,0,.46.55.664,1,.817.8.357,1.251.562,1.5,1.226a2.611,2.611,0,0,1,.1.613A1.456,1.456,0,0,1,8.527,23.806Z",
    transform: "translate(-2.49 -8.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M20.655,8.291l4.353-3.37L20.655,1.5V3.236H14.1V6.555h6.555Z",
    transform: "translate(-7.563 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M18.453,35.2,14.1,38.57l4.353,3.421V40.255h6.555V36.936H18.453Z",
    transform: "translate(-7.563 -17.991)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCashback2X4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_cashback2x4.7723926cde964c7093a1e92c8088b889.svg";